export default __webpack_public_path__ + "static/media/bean6.3c1b0c80.png";